import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8","key":"svg-1"}]]

const IconCircleLetterB = createReactComponent('outline', 'circle-letter-b', 'CircleLetterB', __iconNode);

export default IconCircleLetterB;